/* eslint-disable no-spaced-func */
/* eslint-disable @typescript-eslint/indent */
import { JobDescription } from 'API';
import { createContext } from 'react';
import { Updater } from 'use-immer';

export const JobDescriptionContext = createContext<
  [
    JobDescription | null,
    Updater<JobDescription | null>,
  ]
  >([
    null,
    () => { },
  ]);

export default JobDescriptionContext;
